import React from 'react';
import Icon from '../../../components/AppIcon';

const AnonymityValidator = ({ violations }) => {
  if (!violations || violations?.length === 0) {
    return (
      <div className="bg-white rounded-2xl p-4 md:p-6 border border-[#10B981]">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center bg-[#10B981]/10 flex-shrink-0">
            <Icon name="ShieldCheck" size={20} color="#10B981" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-[#10B981] mb-1">Anonymity Verified</h3>
            <p className="text-sm md:text-base text-[#6B7280]">
              Your profile maintains complete anonymity with no identifying information detected.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 border border-[#EF4444]">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center bg-[#EF4444]/10 flex-shrink-0">
          <Icon name="AlertTriangle" size={20} color="#EF4444" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-[#EF4444] mb-1">Anonymity Issues Detected</h3>
          <p className="text-sm md:text-base text-[#6B7280]">
            The following items may reveal your identity and should be removed:
          </p>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {violations?.map((violation, index) => (
          <div key={index} className="flex items-start gap-3 p-3 md:p-4 bg-[#FEF2F2] rounded-xl">
            <Icon name="X" size={16} color="#EF4444" className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm md:text-base font-medium text-[#111827] mb-1">{violation?.text}</p>
              <p className="text-xs md:text-sm text-[#6B7280] mb-2">Type: {violation?.type}</p>
              {violation?.suggestion && (
                <div className="flex items-start gap-2 p-2 md:p-3 bg-white rounded-lg">
                  <Icon name="Lightbulb" size={14} color="#F59E0B" className="flex-shrink-0 mt-0.5" />
                  <p className="text-xs md:text-sm text-[#6B7280]">
                    <span className="font-medium text-[#111827]">Suggestion:</span> {violation?.suggestion}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnonymityValidator;